// extracted by mini-css-extract-plugin
export default {"new-team-page":"style_new-team-page__cOjom","new-team-page-footer":"style_new-team-page-footer__iD0xp"};